<script>
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    diff: {
      required: true
    },
    datasetName: {
      required: true
    },
    prefix: {
      default: ''
    }
  },
  data: () => ({
    options: {
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 5,
          bottom: 0
        }
      },
      tooltips: {
        displayColors: false
      },
      legend: {
        display: false
      },
      elements: {
        line: {
          tension: 0
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: function(value) {
                return value.toLocaleString('en');
              }
            }
          }
        ],
        xAxes: [
          {
            type: 'time',
            parser: 'YY-MM-DD',
            gridLines: {
              drawOnChartArea: false
            },
            time: {
              displayFormats: {
                hour: 'MMM D'
              }
            },
            ticks: {
              source: 'data'
            }
          }
        ]
      }
    }
  }),
  name: 'HeadLineChart',
  methods: {
    yAxesLabel: function(value) {
      return this.prefix + value;
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>

<style lang="scss" scoped></style>
